import type { FC } from 'react';
import Image from 'next/image';
import { cn } from '../../../utils/cn';
import { isSteamEconomyImage } from '../../../lib/steamImage';
import { WikiSteamImage } from './WikiSteamImage';

// WHY: next/image пропускает только хосты из images.remotePatterns в next.config.mjs — список должен совпадать
const OPTIMIZED_PREFIXES = ['https://cf92270d-b971-4f1a-9fc8-1cde9031d973.selstorage.ru/wiki/'];

export const isOptimizedImage = (src: string): boolean => OPTIMIZED_PREFIXES.some((prefix) => src.startsWith(prefix));

interface WikiRemoteImageProps {
  src: string;
  alt: string;
  sizes: string;
  className?: string;
  preload?: boolean;
  eager?: boolean;
}

// WHY: eager — картинки первого экрана грузятся сразу, без lazy; preload вдобавок кладёт их в <head> с высоким приоритетом
export const WikiRemoteImage: FC<WikiRemoteImageProps> = ({ src, alt, sizes, className, preload = false, eager = false }) => {
  const loading = preload || eager ? 'eager' : 'lazy';
  if (isSteamEconomyImage(src)) {
    return (
      <WikiSteamImage
        src={src}
        alt={alt}
        sizes={sizes}
        fill
        preload={preload}
        loading={loading}
        fetchPriority={preload ? 'high' : undefined}
        className={cn('object-contain', className)}
      />
    );
  }
  if (isOptimizedImage(src)) {
    return <Image src={src} alt={alt} fill sizes={sizes} preload={preload} loading={loading} className={cn('object-contain', className)} />;
  }
  return (
    <img
      src={src}
      alt={alt}
      loading={loading}
      decoding="async"
      className={cn('absolute inset-0 size-full object-contain', className)}
    />
  );
};
